<template>
    <div class="customer-groups">
        <div class="header-container">
            <div class="title">
                <div class="title-content">
                    <span @click="selectedCustomerGroup = null" style="cursor: pointer">
                        {{ $t("wp.customerGroups") }}
                    </span>
                    <span v-if="selectedCustomerGroup"> > {{ selectedCustomerGroup.name }} </span>
                </div>
            </div>
        </div>
        <div v-if="!selectedCustomerGroup">
            <supsis-table :columns="getGroupColumns()" :rows="customerGroups" />
        </div>
        <div v-else>
            <div class="group-detail-description">{{ selectedCustomerGroup.description }}</div>
            <supsis-table
                :columns="getContactColumns()"
                :rows="contacts"
                :pagination-cursor="paginationCursor"
                @cursor-changed="paginationChanged"
                :top-pagination="true"
                :bottom-pagination="true"
            />
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import SupsisTable from "../../../../components/SupsisTable.vue";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import { MAIL_API } from "../../../../api/mail";
import ActionEdit from "../../../../components/svg/ActionEdit.vue";
import ActionDelete from "../../../../components/svg/ActionDelete.vue";

export default Vue.extend({
    name: "EmailCustomerGroups",
    components: {
        SupsisButton,
        SupsisTable,
    },
    data() {
        return {
            loading: false,
            customerGroups: [],
            contacts: [],
            selectedCustomerGroup: null,
            paginationCursor: {
                page: 1,
                perPage: 20,
                total: 0,
            },
        };
    },
    methods: {
        paginationChanged({ page, perPage }) {
            this.paginationCursor.page = page;
            this.paginationCursor.perPage = perPage;
            this.fetchCustomerGroupContact(page, perPage);
        },
        getGroupColumns() {
            return [
                {
                    field: "name",
                    key: "name",
                    title: this.$t("message.name"),
                },
                {
                    align: "right",
                    field: "actionsSlot",
                    key: "actionsSlot",
                    title: this.$t("message.transactions"),
                    fixed: "right",
                    renderBodyCell: ({ row }) => {
                        return (
                            <div class="action-buttons">
                                <a-button
                                    class="actionButton d-flex align-items-center"
                                    on-click={() => this.showCustomerGroupDetail(row)}
                                >
                                    <span style="margin-right: 16px; display: block">{this.$t("task.view")}</span>
                                    <ActionEdit />
                                </a-button>
                                <a-button
                                    class="actionButton d-flex align-items-center"
                                    on-click={() => this.deleteGroup(row._id)}
                                >
                                    <span style="margin-right: 16px; display: block">{this.$t("message.delete")}</span>
                                    <ActionDelete />
                                </a-button>
                            </div>
                        );
                    },
                },
            ];
        },
        getContactColumns() {
            return [
                {
                    field: "fullname",
                    key: "fullname",
                    title: this.$t("message.fullName"),
                },
                {
                    field: "email",
                    key: "email",
                    title: this.$t("message.email"),
                },
                {
                    field: "phone",
                    key: "phone",
                    title: this.$t("message.phone"),
                },
            ];
        },
        async deleteGroup(groupId) {
            try {
                await MAIL_API.BROADCAST.deleteEmailCustomerGroup(groupId);
                this.customerGroups = this.customerGroups.filter((group) => group._id !== groupId);
                this.$message.success(this.$t("message.groupDeletedSuccessfully"));
            } catch (error) {
                console.error("Error deleting group:", error);
                this.$message.error(this.$t("message.failedToDeleteGroup"));
            }
        },
        async fetch() {
            this.loading = true;
            try {
                const response = await MAIL_API.BROADCAST.getCustomerGroups();
                this.customerGroups = response.data;
            } catch (error) {
                console.error("Error fetching groups:", error);
                this.$message.error(this.$t("message.failedToDeleteGroups"));
            } finally {
                this.loading = false;
            }
        },
        showCustomerGroupDetail(group) {
            this.selectedCustomerGroup = group;
            this.fetchCustomerGroupContact(1, 10);
        },
        async fetchCustomerGroupContact(page, perPage) {
            this.loading = true;
            try {
                const res = await MAIL_API.BROADCAST.getCustomerGroupContacts(
                    this.selectedCustomerGroup._id,
                    page,
                    perPage
                );
                const { visitors, total } = res.data;
                this.contacts = visitors;
                this.paginationCursor.total = total;
            } catch (error) {
                console.error("Error fetching group contacts:", error);
                this.$message.error(this.$t("message.failedToFetchGroupContacts"));
            } finally {
                this.loading = false;
            }
        },
    },
    mounted() {
        this.fetch();
    },
});
</script>

<style lang="scss">
.customer-groups {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;

    .header-container {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title {
            .title-content {
                color: #22272d;
                font-weight: 500;
                line-height: 31px;
                font-size: 24px;

                span {
                    cursor: pointer;
                }
            }
        }
    }

    .group-detail-description {
        font-size: 16px;
        color: #666;
        margin-bottom: 16px;
        font-weight: 400;
    }

    .action-buttons {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .actionButton {
            display: flex;
            align-items: center;
            text-wrap: none;
            gap: 4px;
        }
    }
}
</style>
